import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const columnWidth = '260px';
export const Container = styled.aside`
  flex: 0 0 ${columnWidth};
  position: relative;
`;

export const Fixed = styled.div`
  display: flex;
  position: fixed;
  width: ${columnWidth};
  z-index: 100;
  height: 100%;
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 10px;
    right: 0;
    box-shadow: 0px 0px 15px 0px #0f255a33;
  }
`;
export const Content = styled.div`
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 28px;
  z-index: 2;
`;

export const Space = styled.div`
  flex: 1 0 auto;
`;

export const Support = styled.div`
  margin-top: 32px;
  padding: 0 28px;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: rgba(9, 21, 38, 0.6);
`;

export const SupportMail = styled.a``;

export const SupportPhone = styled.a`
  margin-left: 12px;
`;

const activeClassName = 'NavLinkActive';

export const Link = styled(NavLink).attrs({
  activeClassName,
})`

  display: block;
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  text-transform: uppercase;
  color: rgba(9, 21, 38, 0.35);
  outline: none;
  border-radius: 30px;
  padding: 10px 14px;
  margin: 12px 14px 0;
  &:hover {
    color: rgba(9, 21, 38, 0.85);
  }
  &.${activeClassName} {
    background-color: #f4f5f6;
    color: rgba(9, 21, 38, 0.6);
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 71px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #bddee3;
  padding: 0 28px;
  flex: 0 0 auto;
`;

export const Nav = styled.nav``;
